module.exports = __webpack_public_path__ + "static/media/m10.262f59a0.jpg";